/// <reference types="vite/client" />
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import { findObjWithType } from '@odmonorepo/odfunctions';
import useParties from '../useParties/useParties';
import { Address, Profile } from 'merchant-api/types';
import { spiceroad } from '..';

export interface UsePersons {
  isLoading: boolean;
  person: Profile | undefined;
  personAddress: Address;
  personPhoneNumber: string;
  fullName: string | undefined;
  isError: any;
  email: string;
  query: UseQueryResult<Profile>;
}

const getEmail = (data: Profile) =>
  data?.contacts?.filter((contact) => contact.type === 'EMAIL_ADDRESS')[0]
    .value;

const getPerson = (personId: string) =>
  spiceroad.get<Profile>(`/v1/persons/${personId}`).then((res) => res.data);

export const getPersonOpts = (personId: string) =>
  queryOptions<Profile>({
    queryKey: ['person', personId],
    queryFn: () => getPerson(personId),
  });

export function usePersons(): UsePersons {
  const { personId, isLoadingParties, isRenewal } = useParties();

  const query = useQuery({
    ...getPersonOpts(personId!),
    throwOnError: false,
    enabled: isRenewal && !!personId,
  });
  const { data, error, isLoading } = query;

  return {
    person: data,
    personAddress: findObjWithType(data?.addresses, 'PHYSICAL_ADDRESS'),
    personPhoneNumber: findObjWithType(data?.contacts, 'PHONE_NUMBER')?.value,
    email: data ? getEmail(data) : '',
    fullName: data?.fullName,
    isLoading: isLoading || isLoadingParties,
    isError: error,
    query,
  };
}

export default usePersons;
